/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { FunCode, UserPointLog } from '@/api/types/user';

export interface StoreUserCodeMineState {
  code: FunCode;
  codes: FunCode[];
  pointLogs: UserPointLog[];
}

export default {
  namespaced: true,
  state: {
    code: null,
    codes: [],
    pointLogs: [],
  },
  getters: {},
  actions: {
    [USER.GET_CODE]({ state, commit }, { id, reload }) {
      if (!state.code || state.code.id !== id) {
        reload = true;
      }
      if (reload) {
        return new Promise((resolve, reject) => {
          api.getCode(id).then((res) => {
            commit(USER.GET_CODE, res.data);
            resolve(state.code);
          }).catch(reject);
        });
      }
      return Promise.resolve(state.code);
    },
    [USER.GET_CODE_LIST]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getCodeMine().then((res) => {
          commit(USER.GET_CODE_LIST, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.GET_POINT_LOGS]({ commit }, { kw, limit, point }) {
      return new Promise((resolve, reject) => {
        api.getPointLogs(kw, limit, point).then((res) => {
          commit(USER.GET_POINT_LOGS, res.data);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_CODE](state, code) {
      state.code = code;
    },
    [USER.GET_CODE_LIST](state, data) {
      state.codes = data;
    },
    [USER.GET_POINT_LOGS](state, pointLogs) {
      state.pointLogs = pointLogs;
    },
  },
};
